import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { actions } from 'store';
import { ModalButtonWithForm } from 'components/common';
import { FormGroup, Text } from 'components/common/form';

import type { AdminGroup } from 'shared-types';
import type { ApiDataHookUpdateHandler } from 'lib/api/useApiData';
import type { IAdminGroupsUpdate } from './AdminGroups';

interface Props {
  adminGroup: AdminGroup;
  updateGroups:
    | ApiDataHookUpdateHandler
    | ((obj: IAdminGroupsUpdate) => Promise<void>);
}

const AdminGroupsUpdate = ({ adminGroup, updateGroups }: Props) => {
  const { dispatch } = useDispatch();

  const { messages } = useReduxState();

  const handleSubmit = async ({ title }: { title: string }) => {
    try {
      await api.put(`/admin/admin-groups/${adminGroup.id}`, { title });
      await updateGroups({});
      dispatch(
        actions.addNotice({
          text: messages.adminGroupsUpdateGroupSuccess,
          type: 'success'
        })
      );
    } catch (err) {
      await dispatch.handleErrorDispatch(err);
    }
  };

  const validateTitle = async (value: string) => {
    if (!value) return messages.commonTitleEmpty;

    try {
      await api.head(
        `/admin/admin-groups?title=${value}&id=ne|${adminGroup.id}`
      );
      return messages.commonTitleInUse;
    } catch (err) {
      return undefined;
    }
  };

  return (
    <ModalButtonWithForm
      buttonIcon="pen"
      buttonIsDropdown={true}
      buttonSize="header"
      buttonStyle={{ whiteSpace: 'nowrap' }}
      buttonText={messages.adminGroupsUpdateGroup}
      buttonCategory="success"
      modalActionText={messages.commonSave}
      modalTitle={messages.adminGroupsUpdateGroup}
      onSubmit={handleSubmit}
      pristineIsValid={false}
    >
      {() => (
        <FormGroup label={messages.commonTitle}>
          <Text
            customValidateAsync={validateTitle}
            id={`title-${adminGroup.id}`}
            initialValue={adminGroup.title}
            field="title"
          />
        </FormGroup>
      )}
    </ModalButtonWithForm>
  );
};

export default AdminGroupsUpdate;
